import type { PluginRouteFactory } from "@d12labs/plugins/types";
import { createRoute } from "@tanstack/react-router";
import { lazy } from "react";

const ContactsListPage = lazy(() =>
	import("./pages/contacts-list.page").then((m) => ({ default: m.ContactsListPage })),
);
const ContactCreatePage = lazy(() =>
	import("./pages/contact-create.page").then((m) => ({ default: m.ContactCreatePage })),
);
const ContactDetailPage = lazy(() =>
	import("./pages/contact-detail.page").then((m) => ({ default: m.ContactDetailPage })),
);
const PipelinePage = lazy(() =>
	import("./pages/pipeline.page").then((m) => ({ default: m.PipelinePage })),
);

type ContactsListSearch = { q: string; page: number };
type ContactDetailSearch = { activityType: string; activityPage: number };

const ACTIVITY_TYPES = ["email_sent", "deal_created", "deal_status_changed", "attachment_uploaded"];

export const createPluginRoutes: PluginRouteFactory = (parentRoute) => [
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/crm",
		component: ContactsListPage,
		validateSearch: (search: Record<string, unknown>): ContactsListSearch => ({
			q: typeof search.q === "string" ? search.q : "",
			page:
				Number.isInteger(search.page) && (search.page as number) >= 1 ? (search.page as number) : 1,
		}),
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/crm/contacts/new",
		component: ContactCreatePage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/crm/contacts/$id",
		component: ContactDetailPage,
		validateSearch: (search: Record<string, unknown>): ContactDetailSearch => ({
			activityType:
				typeof search.activityType === "string" && ACTIVITY_TYPES.includes(search.activityType)
					? search.activityType
					: "",
			activityPage:
				Number.isInteger(search.activityPage) && (search.activityPage as number) >= 1
					? (search.activityPage as number)
					: 1,
		}),
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/crm/pipeline",
		component: PipelinePage,
	}),
];
